import {inject} from '@angular/core';
import {CanMatchFn, Route, Router} from '@angular/router';
import { AuthService } from '../services/auth.service';

export const isAdminMatchGuard: CanMatchFn = (route: Route): boolean => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const currentUser = authService.getUser();

    if (currentUser && currentUser.roles.indexOf('ADMIN') >= 0) {
        return true;
    } else {
        router.navigate(['/auth']).then();
        return false;
    }
};
